module.exports = __webpack_public_path__ + "static/media/practica1_ml.b699d722.ipynb";